import * as React from "react";

/** Set the browser-tab title for the current page.
 *
 * Every page shared the static "Repoworks" title, so ten open tabs
 * were indistinguishable. Pass the page-specific part; the product
 * name stays as a suffix. Restores the previous title on unmount so
 * closing a drawer/route doesn't leave a stale name.
 */
export function usePageTitle(title: string | null | undefined): void {
  React.useEffect(() => {
    if (!title) return;
    const previous = document.title;
    const next = `${title} · Repoworks`;
    document.title = next;
    return () => {
      // Restore only if nobody else changed it meanwhile — several
      // siblings restoring in order used to re-install a stale title.
      if (document.title === next) document.title = previous;
    };
  }, [title]);
}
